import { lazy } from 'react';

export const AdminBillingPage = lazy(() => import('./AdminBillingPage'));
